import { Application } from "@hotwired/stimulus";
import { StimulusControllers } from "../Shared/Generated/StimulusControllers";
import BranchResolverController from "./BranchResolverController";
const application = Application.start();
// Never send matching/source URLs through the shared client error logger.
application.handleError = () => undefined;
application.register(StimulusControllers.branchResolver, BranchResolverController);
